// SplitView - renders components side by side with equal width, each independently scrollable
function SplitView({ children }) {
  const childrenArray = Array.isArray(children) ? children : [children];
  const count = childrenArray.length;

  if (count === 0) return null;
  if (count === 1) return children;

  return (
    <div className="flex h-full">
      {childrenArray.map((child, index) => (
        <div key={index} className="flex-1 border-r border-border last:border-r-0 h-full flex flex-col overflow-hidden">
          {child}
        </div>
      ))}
    </div>
  );
}

export default SplitView;
